import React from "react"
import { Link } from "gatsby"

import { sPagination } from "../styled/pagination"

const Pagination = ({ baseUrl, pageCount, initialPage }) => {
  const range = Math.min(9, pageCount)
  let minBound = Math.floor(initialPage - range / 2)
  let maxBound = Math.floor(initialPage + range / 2)

  while (!(minBound >= 1 && maxBound <= pageCount)) {
    if (minBound < 2) {
      minBound += 1
      if (maxBound < pageCount) {
        maxBound += 1
      }
    } else {
      if (minBound > 1) {
        minBound -= 1
      }
      maxBound -= 1
    }
  }

  let pages = []
  for (let i = minBound; i <= maxBound; i++) {
    pages.push(
      <sPagination.Number
        key={i}
        to={`${baseUrl}${i > 1 ? `/${i}/` : `/`}`}
        className={i === initialPage ? `active` : null}
      >
        {i}
      </sPagination.Number>
    )
  }

  return (
    <sPagination.Wrapper>
      {initialPage > 1 ? (
        <Link className="icon-left" to={`${baseUrl}${initialPage > 2 ? `/${initialPage - 1}/` : `/`}`} />
      ) : null}
      <sPagination.Numbers>{pages}</sPagination.Numbers>
      {initialPage < pageCount ? <Link className="icon-right" to={`${baseUrl}${`/${initialPage + 1}`}/`} /> : null}
    </sPagination.Wrapper>
  )
}

export default Pagination
